import React from 'react';
import { mockData } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const RetailLoans = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium mb-4">
            Retail Loans
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Personal Financial Solutions
          </h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            {mockData.retailLoans.intro}
          </p>
        </div>

        {/* Loan Types */}
        <div className="space-y-8">
          {mockData.retailLoans.types.map((loan) => (
            <div 
              key={loan.title}
              className="bg-gradient-to-br from-white to-cyan-50/30 rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow border border-cyan-100"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-lg flex items-center justify-center">
                    <CheckCircle className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{loan.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{loan.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RetailLoans;
